export default {
    data: {
        preview: {
            columns: [
                {
                    headerName: 'Id',
                    field: 'id',
                    type: 'string',
                },
                {
                    headerName: 'Name',
                    field: 'name',
                    type: 'string',
                },
                {
                    headerName: 'Hq Country',
                    field: 'hqCountry',
                    type: 'select',
                    selectGroup: 'hqCountry',
                },
            ],
            selectGroups: {
                hqCountry: {
                    'United States': 'United States',
                    Andorra: 'Andorra',
                    Spain: 'Spain',
                },
            },
            rows: [
                {
                    _inputRowId: 1,
                    name: 'ventures',
                    hqCountry: [
                        'United States',
                    ],
                    id: null,
                },
                {
                    _inputRowId: 2,
                    name: 'ventures 2',
                    hqCountry: [
                        'United States',
                    ],
                    id: null,
                },
                {
                    _inputRowId: 3,
                    name: 'ventures 3',
                    hqCountry: [
                        'United States',
                    ],
                    id: null,
                },
                {
                    _inputRowId: 4,
                    name: 'ventures 4',
                    hqCountry: [
                        'United States',
                    ],
                    id: null,
                },
            ],
        },
        import: {
            id: 154,
            name: 'Test: GP to match',
            entity: 'gps',
            source: 'excellow',
            type: 'gps',
            status: 'pending_review',
            phase: 'validation',
            numErrors: 4,
            numWarnings: 0,
            numAddedRows: null,
            numUpdatedCells: null,
            createdAt: '2020-05-11T13:49:25.000Z',
            updatedAt: '2020-05-13T12:38:23.000Z',
            archived: false,
        },
        globalIssues: [],
        rowIssues: [
            {
                type: 'select',
                level: 'error',
                message: 'Found match at row 1 for rule levenshtein:name,hqCountry (10 options)',
                row: 1,
                field: 'id',
                options: [
                    {
                        value: 106,
                        label: '7-Ventures, United States',
                    },
                    {
                        value: 2695,
                        label: 'e.ventures, United States',
                    },
                    {
                        value: 4607,
                        label: 'J Ventures, United States',
                    },
                    {
                        value: 5230,
                        label: 'M Ventures, United States',
                    },
                    {
                        value: 9380,
                        label: 'Y Ventures, United States',
                    },
                    {
                        value: 9451,
                        label: 'zVentures, United States',
                    },
                    {
                        value: 49,
                        label: '30Ventures, United States',
                    },
                    {
                        value: 76,
                        label: '42 Ventures, United States',
                    },
                    {
                        value: 288,
                        label: 'adventur.es, United States',
                    },
                    {
                        value: 367,
                        label: 'AJ Ventures, United States',
                    },
                    {
                        value: 'new',
                        label: 'New Row',
                    },
                    {
                        value: 'search',
                        endpoint: '/outputs/gps/search',
                    },
                ],
            },
            {
                type: 'select',
                level: 'error',
                message: 'Found match at row 1 for rule levenshtein:name,hqCountry (10 options)',
                row: 2,
                field: 'id',
                options: [
                    {
                        value: 106,
                        label: '7-Ventures, United States',
                    },
                    {
                        value: 2695,
                        label: 'e.ventures, United States',
                    },
                    {
                        value: 4607,
                        label: 'J Ventures, United States',
                    },
                    {
                        value: 5230,
                        label: 'M Ventures, United States',
                    },
                    {
                        value: 9380,
                        label: 'Y Ventures, United States',
                    },
                    {
                        value: 9451,
                        label: 'zVentures, United States',
                    },
                    {
                        value: 49,
                        label: '30Ventures, United States',
                    },
                    {
                        value: 76,
                        label: '42 Ventures, United States',
                    },
                    {
                        value: 288,
                        label: 'adventur.es, United States',
                    },
                    {
                        value: 367,
                        label: 'AJ Ventures, United States',
                    },
                    {
                        value: 'new',
                        label: 'New Row',
                    },
                    {
                        value: 'search',
                        endpoint: '/outputs/gps/search',
                    },
                ],
            },
        ],
        cellIssues: [
            {
                type: 'text',
                level: 'error',
                message: 'Found match at row 1 for rule levenshtein:name,hqCountry (10 options)',
                row: 3,
                field: 'name',
            },
            {
                type: 'text',
                level: 'error',
                message: 'Found match at row 1 for rule levenshtein:name,hqCountry (10 options)',
                row: 3,
                field: 'hqCountry',
            },
        ],
    },
}
